export default __webpack_public_path__ + "static/media/WStore_HotelBooking.aa3424b5.png";